import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClientService: HttpClientService) { }


  async getByIdUser(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.User,
      action: "GetByIdUser"
    }, id);
    return await firstValueFrom(observable);
  }

  async registerUser(userName: string, password: string, email: string, personId?: number) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.User
    }, {
      userName: userName,
      email: email,
      password: password,
      passwordConfirm: password,
      personId: personId ?? null
    })

    return await firstValueFrom(observable);
  }

  async updateUser(id, userName: string, password: string, personId?: number, email?: string) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.User,
      action: "UpdateUser"
    }, {
      id: id,
      userName: userName,
      personId: personId,
      password: password ?? '',
      email: email
    });

    return await firstValueFrom(observable);
  }

  async getAllUsers(seacrh, page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.User,
      queryString: `search=${seacrh}&Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async assignRoleToUser(id: string, roles: string[], successCallBack?: () => void, errorCallBack?: (error) => void) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.User,
      action: "assign-role-to-user"
    }, {
      userId: id,
      roles: roles,
    });
    return await firstValueFrom(observable);
  }

  async getAccessibleMenus(id: number, successCallBack?: () => void, errorCallBack?: (error) => void) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.User,
      action: "GetAccessibleMenus",

    }, id);
    return await firstValueFrom(observable);
  }

  async changePassword(appuserId, oldPassword: string, newPassword: string, confirmPassword: string) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.User,
      action: "ChangePassword"
    }, {
      appUserId: appuserId,
      oldPassword: oldPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword
    });
    return await firstValueFrom(observable);
  }

  async changeActive(appUserId, isActive) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.User,
      action: "ChangeActive"
    }, {
      appUserId: appUserId,
      isActive: isActive
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
